import { getValidationError } from 'features/products-compare/ducks/selectors/validation';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const useGetHeader = () => {
  const { t } = useTranslation();
  const validationError = useSelector(getValidationError);
  if (validationError === 'productListCount') {
    return t('ui.compare.status-alert-list-header');
  }
  if (validationError === 'listsCount') {
    return t('ui.compare.status-alert-lists-header');
  }
};
